import classNames from "classnames";

export const wrapper = classNames(
    // Mobile
    "mobile:pl-8",
    "mobile:pr-8",
    "mobile:pb-10",
    // "mobile:pt-8",
    "mobile:items-center",
    "mobile:text-center",
    "mobile:flex-col",
    // Tablet
    "tablet:p-10",
    "tablet:items-start",
    "tablet:flex-row",
    // All
    "relative",
    "flex",
    "items-center",
    "justify-center",
    "w-full"
);

const container = classNames(
    // Mobile
    "mobile:items-center",
    //Tablet
    "tablet:items-start",
    // All
    "flex",
    "justify-evenly",
    "max-w-screen-xl"
);
export const evenContainer = classNames(
    container,
    // mobile
    "mobile:flex-row-reverse",
    "mobile:text-right",
    //tablet
    "tablet:flex-row",
    "tablet:text-left"
);
export const oddContainer = classNames(
    container,
    // mobile
    "mobile:flex-row",
    "mobile:text-left",
    //tablet
    "tablet:flex-row-reverse",
    "tablet:text-right"
);

export const img = classNames(
    // Mobile
    "mobile:w-2/5",
    // Tablet
    "tablet:w-1/5",
    // All
    "w-1/5"
);

export const heading = classNames(
    // Mobile
    "mobile:text-3xl",
    "mobile:font-bold",
    "mobile:pr-4",
    "mobile:pl-4",
    "mobile:pt-0.5",
    // Tablet
    "tablet:text-4xl",
    "tablet:pr-4",
    "tablet:pl-4",
    // All

    "font-bold"
);

export const subheading = classNames(
    // Mobile
    // "mobile:text-right",
    "mobile:text-[18px]",
    "mobile:pt-4",
    "mobile:px-4",
    // Tablet
    "tablet:pt-4",
    "tablet:text-2xl",
    "tablet:pr-4",
    "tablet:pl-4",
    // All
    "p-0",
    "font-medium"
);

export const content = classNames(
    // Mobile
    // Tablet
    // All
    "w-8/12",
    "p-0"
);

export const description = classNames(
    // Mobile
    "mobile:pt-5",
    "mobile:text-lg",
    "mobile:text-left",
    // Tablet
    "tablet:pt-6",
    "tablet:text-2xl",
    "tablet:text-left",
    "tablet:pr-4",
    "tablet:pl-4",
    // All
    "font-light"
);

export const subtext = classNames(
    // Mobile
    // "mobile:pt-4",
    // "mobile:pb-5",
    // "mobile:pr-4",
    // "mobile:pl-4",
    // "mobile:italic",
    "mobile:text-light",
    // Tablet
    "tablet:pt-4",
    "tablet:pr-4",
    "tablet:pl-4",
    // All
    "italic"
);

export const disclaimer = classNames(
    // Mobile
    "mobile:pt-4",
    "mobile:pb-5",
    "mobile:pr-0",
    "mobile:pl-0",
    "mobile:italic",
    "mobile:text-light",
    "mobile:text-[14px]",
    // Tablet
    "tablet:pt-4",
    "tablet:pr-4",
    "tablet:pl-4",
    "tablet:text-[18px]",
    // All
);

export const button = classNames(
    // Mobile
    "mobile:w-52",
    "mobile:h-11",
    "mobile:text-lg",
    "mobile:font-semibold",
    // Tablet
    "tablet:w-64",
    "tablet:h-12",
    "tablet:text-xl",
    "tablet:mt-10",
    "tablet:font-normal",
    "tablet:mr-4",
    "tablet:ml-4",
    // All
    "bg-secondary",
    "text-white",
    "rounded-lg"
);
